/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Button, Container, CssBaseline, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import useStyles from '../../../assets/styles/pages/Request';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';

// import svg
import { ReactComponent as IconRequest } from '../../../assets/images/svg/user/icon_pedidos.svg';
import { ReactComponent as IconRate } from '../../../assets/images/svg/user/icon_avaliar.svg';
import { ReactComponent as IconObservation } from '../../../assets/images/svg/shops/request/icon_observacao.svg';
import { ReactComponent as IconSendRequest } from '../../../assets/images/svg/shops/request/icon_enviar.svg';

import imgIconChat from '../../../assets/images/chat.png';

import { useLoadingContext } from '../../../providers/use-loading';
import { useSignInContext } from '../../../providers/use-signin';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { api } from '../../../services';
import { FormatPrice } from '../../../helpers/utils/Formating';
import ColorSituationRequest from '../../../helpers/utils/ColorStatusRequest';
import { getStorege, saveStorege } from '../../../helpers/db_storage';
import ModalConfirmFooter from '../../../components/Modal/ConfirmFooter';

const RequestUser: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data, signingOut } = useSignInContext();
  const navigate = useNavigate();

  const [requests, setRequets] = useState<any>();
  const [requestLocalStoregeCart, setRequestLocalStoregeCart] = useState<any>();
  const [vlTotalStoregeProduct, setVlTotalStoregeProduct] = useState<any>();

  const [openModalConfirmMajority, setOpenModalConfirmMajority] =
    useState(false);
  const [dataModalConfirmMajority, setDataModalConfirmMajority] = useState({
    title: 'Atenção',
    message:
      'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
    idShop: '',
  });

  const dataUserStorageOrder = getStorege(
    '@mais/delivery/authorization/orders',
  );

  const handleToPage = (url: string, replace = false) => {
    if (replace) {
      return navigate(url, { replace: true });
    }
    return navigate(url);
  };

  const handleListRequest = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.indexRequests({
          nr_operacao: 24,
          idUsuario: data.user?.idUsuario || dataUserStorageOrder?.idUsuario,
        });

      setRequets(result.data);
    } catch (error: any) {
      console.log(error);
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'listAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao listar os pedidos');
      }
    } finally {
      createloading(false);
    }
  };

  const handleSetButton = (
    id_situation: number,
    id_request: string,
    id_shop: string,
    flgAvaliation = 0,
  ) => {
    if (
      [-1, 1, 2, 3, 4, 5, 7].find(
        (situation) => Number(situation) === Number(id_situation),
      )
    ) {
      return (
        <Button
          className={classeStyle.btnRequestProductFollow}
          variant="contained"
          onClick={() =>
            handleToPage(
              `/dashboard/user/request/detail/${window.btoa(
                id_request,
              )}/${window.btoa(id_shop)}`,
              false,
            )
          }
        >
          <IconRequest className={classeStyle.iconBtnRequestProduct} />
          <p>Acompanhar Pedido</p>
        </Button>
      );
    }
    if (Number(id_situation) === 0) {
      return (
        <Button
          className={classeStyle.btnRequestProductFollow}
          variant="contained"
          onClick={() =>
            handleToPage(`/shop/request/detail/${window.btoa(id_shop)}`)
          }
        >
          <IconSendRequest className={classeStyle.iconBtnRequestProduct} />
          <p>Enviar pedido</p>
        </Button>
      );
    }
    return (
      <Button
        className={classeStyle.btnRequestProductDetail}
        style={flgAvaliation == 0 && id_situation == 6 ? { width: '80%' } : {}}
        variant="outlined"
        onClick={() =>
          handleToPage(
            `/dashboard/user/request/detail/${window.btoa(
              id_request,
            )}/${window.btoa(id_shop)}`,
            false,
          )
        }
      >
        <IconObservation className={classeStyle.iconBtnRequestProduct} />
        <p className={classeStyle.textBtnRequestProductDetail}>
          Detalhe do pedido
        </p>
      </Button>
    );
  };

  const handleToChat = (orderData: any) => {
    saveStorege('@chat/order', { ...orderData, lat: null, lng: null });
    handleToPage('/dashboard/user/request/chat');
  };

  const handleOpenShop = (id_shop: any, flgMajority: any) => {
    if (flgMajority == 1) {
      setDataModalConfirmMajority({
        title: 'Atenção!',
        message:
          'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
        idShop: id_shop,
      });
      setOpenModalConfirmMajority(true);
      return;
    }

    handleToPage(
      `/shop/detail/list/product/subcategorie/${window.btoa(id_shop)}`,
    );
  };

  useEffect(() => {
    if (data.user?.idUsuario || dataUserStorageOrder?.idUsuario) {
      handleListRequest();
    }
  }, [data.user, dataUserStorageOrder?.idUsuario]);

  useEffect(() => {
    const result = getStorege('@mais/delivery/shop/request/product/cart');
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (result) {
      setRequestLocalStoregeCart(result);
    } else if (
      !dataUserStorage?.idUsuario &&
      !dataUserStorageOrder?.idUsuario
    ) {
      handleToPage('/sign/in', true);
    }
  }, []);

  useEffect(() => {
    async function CalcProduct() {
      if (requestLocalStoregeCart?.pedido_cardapio.length > 0) {
        try {
          const result: ItypeReturnApi =
            await api.apiMaisdelivery.shop.getResultCalcVlCart({
              nr_operacao: 27,
              idUsuario: data.user?.idUsuario,
              ...requestLocalStoregeCart,
            });
          setVlTotalStoregeProduct(result.data?.valor_total || 0);
        } catch (error) {
          toast.error(
            'Ocorreu um erro ao buscar valor total do pedido em andamento',
          );
        }
      }
    }
    CalcProduct();
  }, [requestLocalStoregeCart?.pedido_cardapio.length > 0]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Request" />

      <>
        <CssBaseline />
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          marginBottom="100px"
        >
          {requestLocalStoregeCart?.pedido_cardapio?.length > 0 && (
            <Grid
              container
              item
              textAlign="center"
              justifyContent="space-between"
              alignItems="center"
              className={classeStyle.gridRequestMainShop}
            >
              <Grid
                container
                item
                textAlign="center"
                justifyContent="space-between"
                alignItems="center"
                className={classeStyle.gridRequest}
              >
                <Grid
                  className={classeStyle.gridRequestPhotoText}
                  textAlign="left"
                  justifyContent="left"
                  alignItems="center"
                >
                  <Grid
                    onClick={() =>
                      handleOpenShop(
                        requestLocalStoregeCart.idRestaurante,
                        requestLocalStoregeCart.flgMaiorIdade,
                      )
                    }
                  >
                    <img
                      src={`${process.env.REACT_APP_API_IMG}${requestLocalStoregeCart.dsImagemEstabelecimento}`}
                      alt="banner"
                      className={classeStyle.bannerShop}
                    />
                  </Grid>

                  <Grid marginLeft="10px">
                    <h4 className={classeStyle.titleRequestShop}>
                      {requestLocalStoregeCart.dsNomeEstabelecimento}
                    </h4>
                    <p className={classeStyle.textDesRequestShop}>
                      Não enviado
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid>
                <Grid container alignItems="center">
                  <Grid
                    style={{
                      width: 15,
                      height: 15,
                      backgroundColor: `${ColorSituationRequest(
                        requestLocalStoregeCart.idSituacao,
                      )}`,
                      borderRadius: 15,
                    }}
                  />
                  <p className={classeStyle.textDesRequest}>Não enviado</p>
                </Grid>

                <Grid container item>
                  <p className={classeStyle.textDesRequestTotal}>Total:</p>
                  <h5 className={classeStyle.textDesRequestTotalValue}>
                    {' '}
                    R$ {FormatPrice(vlTotalStoregeProduct || 0)}
                  </h5>
                  <h5 className={classeStyle.textDesRequestTotalValue}> </h5>
                </Grid>
              </Grid>
              <Grid className={classeStyle.gridBtnRequestProduct}>
                {handleSetButton(
                  requestLocalStoregeCart.idSituacao,
                  '0',
                  requestLocalStoregeCart.pedido.idRestaurante,
                )}
              </Grid>
            </Grid>
          )}
          {requests?.length > 0 &&
            requests.map((requestData: any) => (
              <Grid
                container
                item
                textAlign="center"
                justifyContent="space-between"
                alignItems="center"
                key={requestData.idPedido}
                className={classeStyle.gridRequestMainShop}
              >
                <Grid
                  container
                  item
                  textAlign="center"
                  justifyContent="space-between"
                  alignItems="center"
                  className={classeStyle.gridRequest}
                >
                  <Grid
                    className={classeStyle.gridRequestPhotoText}
                    textAlign="left"
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid
                      onClick={() =>
                        handleOpenShop(
                          requestData.idRestaurante,
                          requestData.flgMaiorIdade,
                        )
                      }
                    >
                      <img
                        src={`${process.env.REACT_APP_API_IMG}${requestData.dsImagem}`}
                        alt="banner"
                        className={classeStyle.bannerShop}
                      />
                    </Grid>

                    <Grid marginLeft="10px">
                      <h4 className={classeStyle.titleRequestShop}>
                        {requestData.dsNome}
                      </h4>
                      <p className={classeStyle.textDesRequestShop}>
                        {moment(
                          requestData.dtPedido,
                          'DD/MM/YYYY HH:mm:SS',
                        ).format('lll')}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid width="100%">
                  <Grid container alignItems="center">
                    <Grid
                      style={{
                        width: 15,
                        height: 15,
                        backgroundColor: `${ColorSituationRequest(
                          requestData.idSituacao,
                        )}`,
                        borderRadius: 15,
                      }}
                    />
                    <p className={classeStyle.textDesRequest}>
                      {requestData.dsSituacao} | Pedido #{requestData.idPedido}
                    </p>
                  </Grid>

                  <Grid
                    container
                    item
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid display="flex">
                      <p className={classeStyle.textDesRequestTotal}>Total: </p>
                      <h5 className={classeStyle.textDesRequestTotalValue}>
                        {' '}
                        R$ {requestData.vlTotal}
                      </h5>
                    </Grid>
                    {[1, 2, 3, 4, 5, 7].filter(
                      (situcao) => situcao == requestData.idSituacao,
                    ).length == 1 && (
                      <Grid display="flex">
                        <Button
                          className={
                            requestData?.qtMensagemPendenteCliente > 0
                              ? classeStyle.btnChatRed
                              : classeStyle.btnChat
                          }
                          onClick={() => handleToChat(requestData)}
                        >
                          <img
                            className={classeStyle.imgIconChat}
                            src={imgIconChat}
                            alt="IconChat"
                          />
                          {requestData?.qtMensagemPendenteCliente}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid className={classeStyle.gridBtnRequestProduct}>
                  {handleSetButton(
                    requestData.idSituacao,
                    requestData.idPedido,
                    requestData.idRestaurante,
                    requestData.flgNotAvaliacao,
                  )}
                  {parseInt(requestData.flgNotAvaliacao, 10) === 0 &&
                    requestData.idSituacao == 6 && (
                      <Button
                        className={classeStyle.btnRequestProductRate}
                        variant="contained"
                        onClick={() =>
                          handleToPage(
                            `/dashboard/user/request/detail/rate/${window.btoa(
                              JSON.stringify({
                                idPedido: requestData.idPedido,
                                idRestaurante: requestData.idRestaurante,
                                dsNome: requestData.dsNome,
                                dtPedido: requestData.dtPedido,
                                idEntregador: requestData.idEntregador,
                              }),
                            )}`,
                          )
                        }
                      >
                        <IconRate />
                      </Button>
                    )}
                </Grid>
              </Grid>
            ))}
        </Grid>
      </>

      <FooterMenuMain children="Request" />
      <ModalConfirmFooter
        isOpen={openModalConfirmMajority}
        title={dataModalConfirmMajority.title}
        message={dataModalConfirmMajority.message}
        btnNamePrimary="Sim, tenho 18+"
        btnNameSecondary="Não, voltar"
        btnCancel=""
        handleFn={async () =>
          handleOpenShop(dataModalConfirmMajority.idShop, 0)
        }
        handleFn2={async () => setOpenModalConfirmMajority(false)}
        onClose={() => setOpenModalConfirmMajority(false)}
      />
    </Container>
  );
};

export default RequestUser;
